module.exports = __webpack_public_path__ + "static/media/lokobee-logo_V.7413fab5.png";